(() => {
    let doc = document,
		body = doc.body;

    const checkScroll = () => {
		let top = window.pageYOffset || doc.documentElement.scrollTop;
		if (top > 0) body.classList.add('scrolled');
		else body.classList.remove('scrolled');
	};

	window.onscroll = function (e) {
		checkScroll();
	};
    
	checkScroll();

	// Mobile nav toggle
	const toggle = doc.querySelector('.header__toggle');
	const mobileNav = doc.querySelector('.mobile-nav');
	const closeBtn = doc.querySelector('.mobile-nav__close');

	const closeMobileNav = () => {
		toggle.classList.remove('active');
		mobileNav.classList.remove('active');
		body.classList.remove('nav-open');
		toggle.setAttribute('aria-expanded', 'false');
	};

	if (toggle && mobileNav) {
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('active');
			mobileNav.classList.toggle('active');
			body.classList.toggle('nav-open');
			toggle.setAttribute('aria-expanded', toggle.classList.contains('active'));
		});

		if (closeBtn) {
			closeBtn.addEventListener('click', closeMobileNav);
		}
	}

	// Make the whole Gravity Forms file upload area clickable
	doc.addEventListener('click', (e) => {
		const uploadArea = e.target.closest('.ginput_container_fileupload');
		if (!uploadArea) return;

		// Let native clicks on the actual controls and previews pass through
		if (e.target.closest('.gform_button_select_files, input[type="file"], .ginput_preview, a, button')) return;

		const selectButton = uploadArea.querySelector('.gform_button_select_files');
		const fileInput = uploadArea.querySelector('input[type="file"]');

		if (selectButton) {
			selectButton.click();
		} else if (fileInput) {
			fileInput.click();
		}
	});

	// Drag-and-drop support for basic (single-file) Gravity Forms file upload
	// (Multi-file mode uses Plupload which already handles drag-and-drop natively on .gform_drop_area)
	doc.querySelectorAll('.ginput_container_fileupload').forEach((area) => {
		// Skip if Plupload drop area exists — Plupload handles drag-drop itself
		if (area.querySelector('.gform_drop_area')) return;

		const fileInput = area.querySelector('input[type="file"]');
		if (!fileInput) return;

		['dragenter', 'dragover'].forEach((evt) => {
			area.addEventListener(evt, (e) => {
				e.preventDefault();
				e.stopPropagation();
				area.classList.add('is-dragover');
			});
		});

		['dragleave', 'dragend'].forEach((evt) => {
			area.addEventListener(evt, (e) => {
				e.preventDefault();
				e.stopPropagation();
				area.classList.remove('is-dragover');
			});
		});

		area.addEventListener('drop', (e) => {
			e.preventDefault();
			e.stopPropagation();
			area.classList.remove('is-dragover');

			const files = e.dataTransfer && e.dataTransfer.files;
			if (!files || files.length === 0) return;

			// Assign dropped files to the native input and trigger change event
			try {
				const dataTransfer = new DataTransfer();
				Array.from(files).forEach((file) => dataTransfer.items.add(file));
				fileInput.files = dataTransfer.files;
				fileInput.dispatchEvent(new Event('change', { bubbles: true }));
			} catch (err) {
				// Fallback: some browsers don't support DataTransfer constructor
				fileInput.files = files;
				fileInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		});
	});

	// Partners slider (continuous scrolling logo ticker)
	if (typeof Swiper !== 'undefined') {
		doc.querySelectorAll('[data-partners-slider]').forEach((el) => {
			new Swiper(el, {
				slidesPerView: 'auto',
				spaceBetween: 0,
				centeredSlides: true,
				loop: true,
				speed: 600,
				grabCursor: true,
				breakpoints: {
					1025: {
						spaceBetween: 64,
					},
				},
			});
		});
	}

	// Image slider
	if (typeof Swiper !== 'undefined') {
		doc.querySelectorAll('[data-image-slider]').forEach((el) => {
			const realCount = parseInt(el.dataset.slideCount, 10) || 1;
			const swiperInstance = new Swiper(el, {
				slidesPerView: 'auto',
				spaceBetween: 16,
				centeredSlides: true,
				loop: true,
				speed: 600,
				grabCursor: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: el.querySelector('.image-slider-section__pagination'),
					clickable: true,
					renderBullet: function (index, className) {
						if (index >= realCount) return '';
						return '<span class="' + className + '" data-bullet-index="' + index + '"></span>';
					},
				},
			});

			swiperInstance.update();
			swiperInstance.slideToLoop(0, 0, false);

			swiperInstance.on('slideChangeTransitionStart', function () {
				swiperInstance.update();
				const target = swiperInstance.snapGrid[swiperInstance.activeIndex];
				if (typeof target === 'number') {
					swiperInstance.translateTo(-target, swiperInstance.params.speed);
				}
			});

			swiperInstance.on('slideChange', function () {
				const mapped = swiperInstance.realIndex % realCount;
				const bullets = el.querySelectorAll('.swiper-pagination-bullet');
				bullets.forEach((bullet) => {
					const idx = parseInt(bullet.dataset.bulletIndex, 10);
					bullet.classList.toggle('swiper-pagination-bullet-active', idx === mapped);
				});
			});
		});
	}

	// Image text slider
	if (typeof Swiper !== 'undefined') {
		doc.querySelectorAll('[data-image-text-slider]').forEach((el) => {
			new Swiper(el, {
				slidesPerView: 1,
				loop: true,
				speed: 600,
				grabCursor: true,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				pagination: {
					el: el.querySelector('.image-text-section__pagination'),
					clickable: true,
				},
			});
		});
	}

	//Animate elements
	const animatedElements = document.querySelectorAll(
		'.fade-in, .slide-in-from-top, .slide-in-from-bottom, .slide-in-from-left, .slide-in-from-right, .treatments-section__grid'
	);
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate');
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: 0.1 }
	);
	animatedElements.forEach((el) => observer.observe(el));
})();